import { Dispatch, SetStateAction, createContext, useContext, useState } from 'react'

import { ScamExportFiltersApiDTO, ScamExportPeriodApiDTO } from '../codegen/generated/Api.schemas'

type ExportsContextType = {
  scam: {
    filters: ScamExportFiltersApiDTO
    period: ScamExportPeriodApiDTO
  }
}

type ExportsDispatchContextType = {
  setSCAMFilters: Dispatch<SetStateAction<ScamExportFiltersApiDTO>>
  setSCAMPeriod: Dispatch<SetStateAction<ScamExportPeriodApiDTO>>
}

export const ExportsContext = createContext<ExportsContextType>({} as ExportsContextType)
export const ExportsDispatchContext = createContext<ExportsDispatchContextType>(
  {} as ExportsDispatchContextType,
)

export const useExportsContext = (): ExportsContextType => useContext(ExportsContext)
export const useExportsDispatchContext = (): ExportsDispatchContextType =>
  useContext(ExportsDispatchContext)

export const ExportsProvider = ({
  children,
}: { children: JSX.Element | JSX.Element[] }): JSX.Element => {
  const [scamFilters, setSCAMFilters] = useState<ScamExportFiltersApiDTO>({})
  const [scamPeriod, setSCAMPeriod] = useState<ScamExportPeriodApiDTO>({})

  return (
    <ExportsContext.Provider
      value={{
        scam: {
          filters: scamFilters,
          period: scamPeriod,
        },
      }}
    >
      <ExportsDispatchContext.Provider value={{ setSCAMFilters, setSCAMPeriod }}>
        {children}
      </ExportsDispatchContext.Provider>
    </ExportsContext.Provider>
  )
}
